"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Image = _interopRequireDefault(require("../../Card/Image"));

var _Pill = _interopRequireDefault(require("../../Card/Pill"));

var _Section = _interopRequireDefault(require("../../Card/Section"));

var _Mirador = _interopRequireDefault(require("../../Mirador"));

var _SideBar = _interopRequireDefault(require("../SideBar"));

var _Shelf = _interopRequireDefault(require("./Shelf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    sideBar: {
      textAlign: "center",
      marginTop: theme.spacing(5)
    },
    dialog: {
      minWidth: "80vw",
      maxWidth: "95vw"
    },
    library: {
      background: theme.palette.background.paper,
      paddingBottom: theme.spacing(5),
      minHeight: "100%"
    },
    mirador: {
      height: "80vh !important"
    }
  };
});

var Transition = _react.default.forwardRef(function Transition(props, ref) {
  return _react.default.createElement(_core.Slide, _extends({
    direction: "up",
    ref: ref
  }, props));
});
/**
* Library Moment to interactively visualize works and publications.
*/


function LibraryMoment(props) {
  var color = props.color,
      data = props.data;
  var classes = useStyles();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentBook = _useState2[0],
      setBook = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      sidebar = _useState4[0],
      setSidebar = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      dialog = _useState6[0],
      setDialog = _useState6[1];

  var handleCloseSidebar = function handleCloseSidebar() {
    setSidebar(false);
  };

  var handleSelectBook = function handleSelectBook(book) {
    setBook(book);
    setSidebar(true);
  };

  var handleOpenDialog = function handleOpenDialog() {
    handleCloseSidebar();
    setDialog(true);
  };

  var handleCloseDialog = function handleCloseDialog() {
    setDialog(false);
    setSidebar(true);
  };

  var renderShelves = function renderShelves() {
    var shelves = [];
    Object.entries(data).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      shelves.push(_react.default.createElement(_Shelf.default, _extends({
        onSelect: handleSelectBook
      }, value)));
    });
    return shelves;
  };

  var renderMirador = function renderMirador() {
    if (!(currentBook && currentBook.manifest_url)) return null;
    var manifest_url = currentBook.manifest_url,
        _currentBook$provider = currentBook.provider,
        provider = _currentBook$provider === void 0 ? "IIIF Resource" : _currentBook$provider;
    var config = {
      manifests: {},
      windows: [{
        manifestId: manifest_url,
        "view": "gallery"
      }]
    };
    config.manifests[manifest_url] = {
      provider: provider
    };
    return _react.default.createElement(_Mirador.default, {
      className: classes.mirador,
      config: config
    });
  };

  var renderDialog = function renderDialog() {
    return _react.default.createElement(_core.Dialog, {
      className: "story-library-dialog",
      open: dialog,
      TransitionComponent: Transition,
      onClose: handleCloseDialog,
      classes: {
        paper: classes.dialog
      }
    }, renderMirador());
  };

  var renderSideBarContent = function renderSideBarContent() {
    if (!currentBook) return null;
    var date = currentBook.date,
        description = currentBook.description,
        image = currentBook.image,
        instance = currentBook.instance,
        label = currentBook.label,
        manifest_url = currentBook.manifest_url,
        url = currentBook.url;
    return _react.default.createElement(_core.Grid, {
      container: true,
      spacing: 5,
      justify: "center",
      className: classes.sideBar
    }, _react.default.createElement(_core.Grid, {
      item: true,
      xs: 10
    }, _react.default.createElement(_core.Typography, {
      variant: "h5"
    }, label)), _react.default.createElement(_core.Grid, {
      xs: 12
    }, _react.default.createElement(_core.Divider, {
      variant: "middle"
    })), instance && _react.default.createElement(_core.Grid, {
      item: true,
      xs: 10
    }, _react.default.createElement(_core.Typography, {
      variant: "h6"
    }, instance)), date && _react.default.createElement(_core.Grid, {
      item: true,
      xs: 10
    }, _react.default.createElement(_Pill.default, {
      text: date.label
    })), image && _react.default.createElement(_core.Grid, {
      item: true,
      xs: 10
    }, _react.default.createElement(_Image.default, {
      src: image,
      alt: "Image of ".concat(label)
    })), description && _react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, _react.default.createElement(_Section.default, null, description)), manifest_url && _react.default.createElement(_core.Grid, {
      item: true,
      xs: 4
    }, _react.default.createElement(_core.Button, {
      className: "library-sidebar-link",
      variant: "contained",
      onClick: handleOpenDialog,
      style: {
        background: color.background,
        color: color.text
      }
    }, "Look Inside")), url && _react.default.createElement(_core.Grid, {
      item: true,
      xs: 4
    }, _react.default.createElement(_core.Button, {
      className: "library-sidebar-link",
      variant: "contained",
      href: url,
      target: "_blank"
    }, "Learn More")));
  };

  var layout = "library"; // TODO: Add constant

  return _react.default.createElement(_SideBar.default, _extends({}, props, {
    bodyClassName: classes.library,
    layout: layout,
    onClose: handleCloseSidebar,
    sidebar: sidebar,
    sideBarContent: renderSideBarContent()
  }), renderShelves(), renderDialog());
}

;
LibraryMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),

  /** Stories-API data context to configure the `LibraryShelf` components. */
  data: _propTypes.default.object.isRequired,

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: _propTypes.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: _propTypes.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: _propTypes.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: _propTypes.default.string,

  /** Main heading element of the `Moment` */
  title: _propTypes.default.node,

  /** The type of `Moment` */
  type: _propTypes.default.string
};
LibraryMoment.defaultProps = {
  type: "library",
  data: {}
};
var _default = LibraryMoment;
exports.default = _default;